/**
 * @description обработчик успеха формы
 * */
export default function formSuccess(data) {
  if (!data || !data.form) {
    return false;
  }
  const $html = $(data.html);
  const $form = $(data.form);
  $form.trigger('reset');
  if (!data.html) {
    return false;
  }
  $form.replaceWith($html);
  return { html: $html[0] };
}
